export const FETCH_IDAPS = 'drugs/FETCH_IDAPS'
export const FETCH_IDAPS_DRUG_BY_NAME = 'drugs/FETCH_IDAPS_DRUG_BY_NAME'